import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser";
import { NavigationClient } from "@azure/msal-browser";
import { Capacitor } from "@capacitor/core";

export class NavigationAuthenticationClient extends NavigationClient {
    constructor(msalInstance) {
        super();
        console.log('NavigationAuthenticationClient constructor called');
        this.msalInstance = msalInstance;
    }

    async navigateExternal(url, options) {
        console.log('navigateExternal called with URL:', url);
        if (Capacitor.isNativePlatform()) {
            const browser = InAppBrowser.create(url, "_blank", {
                location: "no",
                hidenavigationbuttons: "yes",
                clearcache: "no",
                clearsessioncache: "no",
                hideurlbar: "yes",
                fullscreen: "yes",
            });
            browser.on("loadstart").subscribe((event) => {
                console.log('Event.URL:', event.url);
                if (event.url.includes("#code")) {
                    browser.close();

                    const domain = event.url.split('#')[0];
                    const redirectBase = Capacitor.getPlatform() === 'ios' 
                        ? 'capacitor://localhost/home' 
                        : 'https://localhost/home';
                    const url = event.url.replace(domain, redirectBase);
                    console.log('will redirect to:', url);
                    window.location.href = url;
                }
                if (event.url.includes("oauth2/v2.0/logoutsession")) {
                    browser.close();
                }

            });
        } else {
            if (options.noHistory) {
                window.location.replace(url);
            } else {
                window.location.assign(url);
            }
        }
        return true;
    }
}
